import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Center, Loader } from '@mantine/core';
import { getCurrentReturnPath, isExplicitLogout, persistReturnPath } from '../utils/authRedirect';

// @ts-ignore
const ProtectedRoute = ({ children }) => {
    const { user, isLoading, isUnauthorized } = useAuth();
    const fullPath = getCurrentReturnPath();

    if (isLoading) {
        return (
            <Center h="100vh">
                <Loader color="blue" style={{ marginTop: '-60px' }} />
            </Center>
        );
    }

    if (user && !isUnauthorized) {
        return children;
    }

    if (isExplicitLogout()) {
        return <Navigate to="/sign-in" replace />;
    }

    persistReturnPath(fullPath);

    return <Navigate to="/sign-in" replace state={{ from: fullPath }} />;
};

export default ProtectedRoute;
